import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class BodySharedFullData extends Vue {
  removeParts = [
    "cough",
    "coughText",
    "mouthAndChin",
    "lungRateOnlyText",
    "activity"
  ];
  additionalPartsToRemove: string[] = [];

  mounted() {
    this.removeParts = this.removeParts.concat(this.additionalPartsToRemove);
  }
}
